import React, { FC, Fragment } from 'react';
import { Paper, Table, TableBody } from '@material-ui/core';
import ScheduledEmailRow from './ScheduledEmailRow';
import { LoadMoreButton } from 'components';

import { UserSegment, ContentEmailSpecFragment } from 'api';
import { Queries } from 'components';

interface IProps {
  segments: UserSegment[];
  scheduledEmails: Queries.IGetContentEmailSpecsResult;
}

const ScheduledEmails: FC<IProps> = props => {
  const { scheduledEmails, segments } = props;
  const { items, loading, paginate, onLoadMore } = scheduledEmails;

  return (
    <Fragment>
      <Paper>
        <Table>
          <TableBody>
            {items.map((emailItem: ContentEmailSpecFragment, index: number) => (
              <ScheduledEmailRow key={index} item={emailItem} index={index} segments={segments} />
            ))}
          </TableBody>
        </Table>
      </Paper>
      {paginate && <LoadMoreButton loading={loading} onClick={onLoadMore} />}
    </Fragment>
  );
};

export default ScheduledEmails;
